<template>
<div class="dashboard-select clear" :class="{'single-select': !showDaily}">
    <div class="select" :class="{'selected': type === 0}" v-if="type === 0 && showDaily">
        <el-select style="position:absolute;left:0;top:0;z-index:2" v-model="current" id="day-choice" @change="detectOption" placeholder=" " @click.native="clickType(0)">
            <el-option
              class="dashboard-select-option position-relative"
              v-for="item in options"
              :disabled="item.isDisable"
              :key="item.code"
              :label="item.title"
              :value="item.code"
              :id="`${item.title}-${item.code}`">
              <div class="text-center">{{ `${item.title}` }}</div>
              <div v-if="item.code == curDay && weekLabel == 'THIS WEEK'" class="cursor-pointer green-circle position-relative" title="Current day"></div>
            </el-option>
        </el-select>
        <div class="label-show-today">{{weekLabel === 'THIS WEEK' ? (current === curDay ? 'Today' : (current === 1 ? 'Mon' : (
          current === 2 ? 'Tue' : (current === 3 ? 'Wed' : (current === 4 ? 'Thu' : (
            current === 5 ? 'Fri' : (current === 6) ? 'Sat' : 'Sun'
          )))))) : (current === 1 ? 'Mon' : (
          current === 2 ? 'Tue' : (current === 3 ? 'Wed' : (current === 4 ? 'Thu' : (
            current === 5 ? 'Fri' : (current === 6) ? 'Sat' : 'Sun'
          )))))}}</div>
    </div>
    <div id="selected-daily" class="daily" @click="clickType(0)" v-if="type === 1 && showDaily">Daily</div>
    <div id="selected-weekly" class="weekly" :class="{'selected-weekly': type === 1}" @click="clickType(1)">Weekly</div>
</div>
</template>

<script>

export default {
  name: 'dayChoice',
  props: {
    // 当前选中的是daily还是weekly
    weekDay: {
      type: Number,
      default: null,
    },
    currentChosen: {
      type: Number,
      default: 0
    },
    // 是否乱序
    showDeputyCycle: {
      type: Boolean,
      default: false
    },
    // 乱序的话从上周几开始
    weekStart: {
      type: Number,
      default: -1
    },
    // 综合下面两个判断。当前周是否为last / this week
    // 所有的周
    weekList: {
      type: Array,
      default: []
    },
    // 当前的周id
    dashBoardId: null,
    isMultiSite: {
      default: false
    },
    isPresent: {
      default: false
    }
  },
  computed: {
    week() {
      let e = this.current
      if (e === 1)
        return 'Mon'
      else if (e === 1)
        return 'Tue'
      if (e === 3)
        return 'Wed'
      if (e === 4)
        return 'Thu'
      if (e === 5)
        return 'Fri'
      if (e === 6)
        return 'Sat'
      if (e === 7)
        return 'Sun'
    }
  },
  data(){
    return {
        type: 0, // 当前选中daily还是weekly
        current: parseInt(sessionStorage.getItem('currentWeekIndex')), // 当前选中的日期
        curDay: parseInt(sessionStorage.getItem('currentWeekIndex')), // 今天
        options: [
          /*{code:1,title: (new Date()).getDay() === 1 ? 'Today' : "Mon",isDisable:true},
          {code:2,title: (new Date()).getDay() === 2 ? 'Today' : "Tue",isDisable:true},
          {code:3,title: (new Date()).getDay() === 3 ? 'Today' : "Wed",isDisable:true},
          {code:4,title: (new Date()).getDay() === 4 ? 'Today' : "Thu",isDisable:true},
          {code:5,title: (new Date()).getDay() === 5 ? 'Today' : "Fri",isDisable:true},
          {code:6,title: (new Date()).getDay() === 6 ? 'Today' : "Sat",isDisable:true},
          {code:7,title: (new Date()).getDay() === 0 ? 'Today' : "Sun",isDisable:true}*/
          {code:1,title: "Mon",isDisable:true},
          {code:2,title: "Tue",isDisable:true},
          {code:3,title: "Wed",isDisable:true},
          {code:4,title: "Thu",isDisable:true},
          {code:5,title: "Fri",isDisable:true},
          {code:6,title: "Sat",isDisable:true},
          {code:7,title: "Sun",isDisable:true}
        ], // 所有下拉的天
        showDaily: true, // 是否展示daily，因为只有last this week才能选择，而且this week还没到来的天，要置灰
        weekLabel: 'THIS WEEK', // 只有this week有today
      
    }
  },
  methods: {
    detectOption(e) {
      // 把选中的天传出去，如果dashBoardId是-1 -2 -3就不用传了
      if (this.dashBoardId === -1 || this.dashBoardId === -2 || this.dashBoardId === -3){
        return
      }
      let currentTimes = this.weekList.find(item => {
          return item.dashBoardId === this.dashBoardId || item.value === this.dashBoardId
      })
      this.$emit('dayChange', e, this.dashBoardId, currentTimes.monDateTime,  currentTimes.sunDateTime)
    },
    clickType(e, toRequest) {
      // 把选中的类别传出去
      if (this.type === e)
        return
      if (e === 1) {
        if (this.weekLabel === 'THIS WEEK')
          this.current = this.curDay
      }
      this.type = e
      this.$emit('typeChange', e, toRequest)
    },
    initThisWeekList() {
      const order = !this.showDeputyCycle
      const weekStart = this.weekStart
      const dates = [
        {code:1,title: "Mon",isDisable:false},
        {code:2,title: "Tue",isDisable:false},
        {code:3,title: "Wed",isDisable:false},
        {code:4,title: "Thu",isDisable:false},
        {code:5,title: "Fri",isDisable:false},
        {code:6,title: "Sat",isDisable:false},
        {code:7,title: "Sun",isDisable:false}
      ];
      let weekDays = [];
      //["Mon","Tue","Wed","Thu","Fri","Sat","Sun"]
      if(order){//正序
        weekDays = dates;
        const dayIndex = weekDays.findIndex(item =>item.code === this.curDay);//获取本周已到跟未到的日期分割索引
        weekDays.forEach((item,index) => {
          item.isDisable = false;
        })
      }else{//乱序
        const num = dates.findIndex(item =>item.code === weekStart);//获取分割上周本周的索引
        const newDays1 = dates.filter((item,index) => index>=num);//上周数据
        const newDays2 = dates.filter((item,index) => index<num);//本周数据
        const dayIndex = dates.findIndex(item =>item.code === this.curDay);//获取本周已到跟未到的日期分割索引
        if(dayIndex||dayIndex===0){
          newDays2.forEach((item,index) => {
            item.isDisable = false;
          })
        }
        weekDays = [...newDays1,...newDays2];
      }
      this.options = weekDays;
    },
    initLastWeekList() {
      const order = !this.showDeputyCycle
      const weekStart = this.weekStart
      const dates = [
        {code:1,title: "Mon",isDisable:false},
        {code:2,title: "Tue",isDisable:false},
        {code:3,title: "Wed",isDisable:false},
        {code:4,title: "Thu",isDisable:false},
        {code:5,title: "Fri",isDisable:false},
        {code:6,title: "Sat",isDisable:false},
        {code:7,title: "Sun",isDisable:false}
      ];
      this.current = this.curDay
      let weekDays = [];
      //["Mon","Tue","Wed","Thu","Fri","Sat","Sun"]
      if(order){//正序
        weekDays = dates;
        const dayIndex = weekDays.findIndex(item =>item.code === this.curDay);//获取本周已到跟未到的日期分割索引
      }else{//乱序
        const num = dates.findIndex(item =>item.code === weekStart);//获取分割上周本周的索引
        const newDays1 = dates.filter((item,index) => index>=num);//上周数据
        const newDays2 = dates.filter((item,index) => index<num);//本周数据
        weekDays = [...newDays1,...newDays2];
      }
      this.options = weekDays;
    },

    loadWeeks() {
      this.initThisWeekList()
    },

    getselectionData(val) {
      // console.log(val)
      if (!val) {
        return
      }

      if (!this.weekList) {
        return
      }
        const nowDay = new Date(),
        // curDay = nowDay.getDay() === 0 ? 7 : nowDay.getDay() === 0 ? 7 : nowDay.getDay();//获取当天是周几
        curDay = this.weekDay;//获取当天是周几
        
        if (this.isMultiSite) {
          if (this.isPresent) {
            this.initThisWeekList()
            this.current = curDay
          } else {
            this.initLastWeekList()
            this.current = 1
          }
          return
        }

        if (val === -3) {
          this.showDaily = false
          this.clickType(1, 'no')
          return
        }
        let weekList = this.weekList

        if (weekList.length === 0) {
          weekList = [
            {
              dashBoardId: -2,
              value: 'LAST WEEK'
            },
            {
              dashBoardId: -1,
              value: 'THIS WEEK'
            },
            {
              dashBoardId: -3,
              value: 'NEXT WEEK'
            }
          ]
        }
        weekList.forEach(item => {
          if (item.dashBoardId === val || item.value === val) {
            this.weekLabel = item.value
            // if (item.value === 'LAST WEEK' || item.value === 'THIS WEEK')
            if (item.value !== 'NEXT WEEK'){
              this.showDaily = true
              if (item.value === 'THIS WEEK') {
                this.initThisWeekList()
                this.current = curDay
              }
              else {
                this.initLastWeekList()
                this.current = 1
              }
            } else{
              this.showDaily = false
              this.clickType(1, 'no')
            }
          }
        })
    },

  },
  watch: {
    // 拿到weekstart的数据就可以开始排序
    weekDay () {
      if (this.weekDay && this.weekDay >= 0) {
        this.current = this.weekDay;
        this.curDay = this.weekDay;
      }
    },
    weekStart: {
      deep: true,
      handler: function (val) {
        if (!this.isMultiSite) {
          this.initThisWeekList()
        }
      }
    },
    // 切换周，要自动选中daily，这里是监听自动选中
    currentChosen: {
      deep: true,
      handler: function (val) {
        this.type = val
      }
    },
    isMultiSite: {
      deep: true,
      handler: function (val) {
        // console.log(val, 'tru')
      }
    },
    // 切换周，监听周的变化，因为只有last / this week可以选择天
    // 周变化，也要重新去生成下拉，因为last week是全部可选的
    dashBoardId: {
      deep: true,
      handler: function (val) {
        this.getselectionData(val)
      }
    },
  },
  created() {
    this.loadWeeks()

    this.getselectionData(this.dashBoardId)

    // if (this.weekDay && this.weekDay >= 0) {
    //     this.current = this.weekDay;
    //     this.curDay = this.weekDay;
    // } else if (this.weekStart && this.weekStart >= 0) {
    //   this.current = this.weekStart;
    //   this.curDay = this.weekStart;
    // }
  }
}
</script>

<style lang="scss" scoped>
@import 'static/scss/colors.scss';

.dashboard-select{
    .el-popper[x-placement^=bottom] {
        margin-bottom: 40px !important;
    }
    margin-bottom: 14px;
    width: 170px;
    border-radius: 4px;
    padding-left: 88px;
    position: relative;
    background-color: var(--background-color-4);
    .select{
        width: 88px;
        height: 40px;
        position: absolute;
        top: 0;
        left: 0;
        .label-show-today{
          position: absolute;
          width: 88px;
          height: 40px;
          line-height: 40px;
          border-radius: 4px;
          z-index: 1;
          background-color: #EA3796;
          box-sizing: border-box;
          padding-left: 15px;
          top: 0;
          left: 0;
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: var(--text-color);
        }
    }
    .weekly{
        border-radius: 4px;
        background-color: var(--background-color-4);
        padding-left: 22px;
        width: 82px;
        float: left;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-color);
        line-height: 40px;
        cursor: pointer;
    }
    .daily{
        border-radius: 4px;
        background-color: var(--background-color-4);
        padding-left: 22px;
        width: 88px;
        float: left;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-color);
        line-height: 40px;
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
    }
    .selected-weekly{
        background-color: var(--primary-color);
        color: #fff !important;
    }
}
.single-select{
  width: 84px !important;
  padding-left: 0 !important;
  .weekly{
    padding-left: 18px !important;
  }
}
.green-circle {
  border-radius: 10px;
  height: 9px;
  width: 9px;
  background-color: $green;
  position: absolute;
  left: 1rem;
  top: calc(50% - 5px);
}


</style>



// WEBPACK FOOTER //
// src/components/dashboard/component/dayChoice.vue